import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, Observable, Subject, throwError, tap } from 'rxjs';
import { UrlData } from 'src/app/kiosk-page/kiosk-page.component';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class ApiHttpService implements HttpInterceptor {
  static Xtenent = 'org_LcsIqfuqLSCPC7A5';
  static siteName = 'Tilal Al Ghaf - Retail Hub';
  static onExit = false;
  siteObservable = new Subject<any>();

  constructor(
    private router: ActivatedRoute,
    private http: HttpClient,
    private snack: MatSnackBar,
    private envService: EnvironmentService
  ) {
    this.router.queryParams.subscribe((params: any) => {
      console.log(params);
      if (params.tenantId && params.siteName) {
        ApiHttpService.Xtenent = params.tenantId;
        ApiHttpService.siteName = params.siteName;
        this.publishObservale({ site: ApiHttpService.siteName })
      }
      if(params.onExit){
        ApiHttpService.onExit = params.onExit
      }
    })
  }
  
  // Method to toggle environment
  toggleEnvironment() {
    this.envService.toggleEnvironment();
    // Show notification
    const envType = this.envService.isDevEnvironment() ? 'Development' : 'Production';
    this.showSuccessCssStyles(`Switched to ${envType} environment`, 'OK', { duration: 3000 });
  }

  // Get current environment label for display
  getCurrentEnvironment(): string {
    return this.envService.isDevEnvironment() ? 'DEV' : 'PROD';
  }

  publishObservale(data: any) {
    this.siteObservable.next(data)
  }
  getObservable(): Observable<any> {
    return this.siteObservable
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log(req)
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (!this.isSuccessStatus(event.status)) {
            const message = this.extractApiMessage(event.body) || `Request failed with status ${event.status}`;
            this.showSnackbarCssStyles(message, 'OK', { duration: 8000 });
          } else if (this.isErrorResponseBody(event.body)) {
            const message = this.extractApiMessage(event.body);
            if (message) {
              this.showSnackbarCssStyles(message, 'OK', { duration: 8000 });
            }
          }
        }
      }),
      catchError((error) => {
        console.log(error)
        this.handleHttpError(error);
        return throwError(() => error);
      }))
  }

  private isSuccessStatus(status?: number): boolean {
    return status === 200 || status === 201;
  }

  private isErrorResponseBody(body: any): boolean {
    if (!body || typeof body !== 'object') {
      return false;
    }
    return body.error != null || body.errors != null || body.success === false || body.status === 'error' || (body.message != null && body.success === false);
  }

  private extractApiMessage(payload: any): string {
    if (!payload) {
      return '';
    }
    if (typeof payload === 'string') {
      return payload;
    }
    if (payload.error) {
      if (typeof payload.error === 'string') {
        return payload.error;
      }
      return payload.error.message || JSON.stringify(payload.error);
    }
    if (payload.message) {
      return payload.message;
    }
    if (payload.errors) {
      if (Array.isArray(payload.errors)) {
        return payload.errors.map((item: any) => {
          if (typeof item === 'string') {
            return item;
          }
          return item?.message || JSON.stringify(item);
        }).join(' | ');
      }
      return typeof payload.errors === 'string' ? payload.errors : JSON.stringify(payload.errors);
    }
    return '';
  }

  private handleHttpError(error: any) {
    const message = this.extractApiMessage(error?.error) || error?.message || 'Network or server error';
    this.showSnackbarCssStyles(message, 'OK', { duration: 8000 });
  }

  showSnackbarCssStyles(content: string, action: string | undefined, duration: any=4000) {
    let sb = this.snack.open(content, action, {
      duration,
      panelClass: ['error'],
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  showSuccessCssStyles(content: string, action: string | undefined, duration: any=4000) {
    let sb = this.snack.open(content, action, {
      duration,
      panelClass: ['success'],
      verticalPosition: 'top'

    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  get(url: String, data?: any): Observable<any> {
    return this.http.get(`${url}`, data)
      .pipe(
        catchError((err) => this.handleHttpErrorAndRethrow(err))
      )
  }
  public post(url: String, data: any, options?: any): Observable<any> {
    return this.http.post(`${url}`, data, options)
      .pipe(
        catchError((err) => this.handleHttpErrorAndRethrow(err))
      )
  }

  private handleHttpErrorAndRethrow(err: any): Observable<never> {
    this.handleHttpError(err);
    return throwError(() => err);
  }
  getStates() {
    console.log("states")
    let headers = new HttpHeaders()
      .set("X-TENANT-ID", ApiHttpService.Xtenent);
    let ApiUrl = `${this.envService.getApiBaseUrl()}/api/v1/state-code/list`;
    return this.get(ApiUrl, { headers: headers, observe: "response" });
  } 

  postRequest(plate: string, state: string, siteName?: string, onExit?: boolean) {
    const siteNameToUse = siteName || ApiHttpService.siteName;
    const onExitToUse = onExit !== undefined ? onExit : ApiHttpService.onExit;
    
    let headers = new HttpHeaders().set("X-TENANT-ID", ApiHttpService.Xtenent); 
    let ApiUrl = `${this.envService.getApiBaseUrl()}/api/v1/public-activities/info?plate=${plate}&state=${state}&site=${siteNameToUse}&onExit=${onExitToUse}`;
    return this.get(ApiUrl, { headers: headers, observe: "response" });
  }
  
  getPaymentMethods(billsPayload?: any[]) {
    let ApiUrl = `${this.envService.getMyFatoorahBaseUrl()}/init-payment`;
    
    // If bills payload is provided, send it as POST request
    if (billsPayload && billsPayload.length > 0) {
      return this.post(ApiUrl, billsPayload);
    }
    
    // Otherwise use the original GET request
    return this.get(ApiUrl);
  }

  executePayment(ids:string, methodId: string, amount: string, currencyIso: string = 'AED') {
    let ApiUrl = `${this.envService.getMyFatoorahBaseUrl()}/execute-payment`;
    const data = {
      ids,
      methodId,
      amount,
      currencyIso
    };
    return this.post(ApiUrl, data);
  }

  pay(data: UrlData[]) {
    let ApiUrl = `${this.envService.getStripeBaseUrl()}/payment-link`;
    return this.post(ApiUrl, data);
  }

  niPay(data: UrlData[]) {
    let ApiUrl = `${this.envService.getNiBaseUrl()}/payment-link`;
    return this.post(ApiUrl, data);
  }

  // KNET payment methods
  knetPay(data: { amount: any; }) {
    let ApiUrl = `${this.envService.getKnetBaseUrl()}/payment-link`;
    return this.post(ApiUrl, data);
  }

  knetGetAmount(data: { licensePlate: any; }) {
    let ApiUrl = `${this.envService.getKnetBaseUrl()}/get-car-fees`;
    return this.post(ApiUrl, data);
  }

  // PayTabs payment method
  paytabsPay(data: UrlData[]) {
    let ApiUrl = `${this.envService.getApiBaseUrl()}/paytabs/payment-link`;
    return this.post(ApiUrl, data);
  }
}